export interface ValidationErrorResponse {
  timestamp: string;
  errors: ValidationError[];
}

export interface ValidationError {
  field: string;
  message: string;
  code: string;
}

export const UNIQUE_VALIDATION_ERROR_CODE = 'UNIQUE';
export const INVALID_OTP_VALIDATION_ERROR_CODE = 'RESOURCE_NOT_FOUND';
export const VALID_EMAIL_ADDRESS_FORMAT_VALIDATION_ERROR_CODE = 'VALID_EMAIL_ADDRESS_FORMAT';
export const IS_NEW_PASSWORD_VALIDATION_ERROR_CODE = 'IS_NEW';
export const SSN_ALREADY_IN_USE_VALIDATION_ERROR_CODE = 'SSN_ALREADY_IN_USE';
export const MONTH_IN_PASSWORD_ERROR_CODE = 'MONTH_ABBREVIATIONS';
export const WEEKDAY_IN_PASSWORD_ERROR_CODE = 'WEEK_DAY_ABBREVIATIONS';
export const BLACKLISTED_IN_PASSWORD_ERROR_CODE = 'BLACKLISTED_TERMS';
export const SPECIAL_CHARS_IN_PASSWORD_ERROR_CODE = 'CHARS_NOT_ALLOWED';
export const NAME_IN_PASSWORD_ERROR_CODE = 'CANNOT_CONTAIN_OTHERS';
export const SSN_FORBIDDEN_ERROR_CODE = 'FORBIDDEN_SYMBOLS';